import { createInstance } from '@adobe/alloy';
import webEvent from './web-event.json';
import api from '../../api';
import * as Bowser from 'bowser';
import { alloyConfig } from '../../config';

const alloy = createInstance({ name: 'alloy' });
const config = alloyConfig();

// SQL Query example: select * from onsemi_web_data_set_3 owds WHERE _onsemi.activityInfo.activityTealiumEvent = 'wdt_download_datasheet'

alloy('configure', {
	edgeConfigId: config.edgeConfigId,
	orgId: config.orgId,
	debugEnabled: config.debugEnabled
});

export const middlePartOfRedirectLink = '/design-tools/linksRedirect?';
export const logEventType = { DATASHEETLOG: 'DatasheetLog' };
const browser = Bowser.getParser(window.navigator.userAgent);

export const adobeDownloadDatasheet = async datasheetTrackingParameters => {
	const { supplyType, vinMin, vinMax, vout, iout } = JSON.parse(datasheetTrackingParameters.inputParameters);
	const we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = datasheetTrackingParameters.redirectLink;
	we._onsemi.activityInfo.activityAssetTitle = `WebDesign+${datasheetTrackingParameters.partNumber}-${supplyType}-${vinMin} to ${vinMax} V ${vout}V at ${iout}A-datasheet`;
	we._onsemi.activityInfo.activityProductName = 'WebDesigner+ Power Supply';
	we._onsemi.activityInfo.activityType = 'Web Designer Tool';
	we._onsemi.activityInfo.activityTealiumEvent = 'wdt_download_datasheet';
	we._onsemi.activityInfo.activityDescription =
		'home/' + datasheetTrackingParameters.wdtTabName + '-' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.wdtTabName = datasheetTrackingParameters.wdtTabName;
	we._onsemi.webInfo.buttonName = datasheetTrackingParameters.buttonName;
	we._onsemi.webInfo.buttonType = 'Download';
	we._onsemi.webInfo.buttonHref = datasheetTrackingParameters.redirectLink;
	we._onsemi.webInfo.fullUrl = datasheetTrackingParameters.fullURL;
	we._onsemi.webInfo.urlPath = datasheetTrackingParameters.path;

	return sendEvent(we);
};

export const adobeOpenMyDesign = designName => {
	const actualURL = window.location.href;
	const linkURL = actualURL.substring(0, actualURL.indexOf('design-tools/') + 13) + 'design';
	const we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = linkURL;
	we._onsemi.activityInfo.activityAssetTitle = `WebDesign+${designName}-design`;
	we._onsemi.activityInfo.activityProductName = 'WebDesigner+ Power Supply';
	we._onsemi.activityInfo.activityType = 'Web Designer Tool';
	we._onsemi.activityInfo.activityTealiumEvent = 'wdt_open_design';
	we._onsemi.activityInfo.activityDescription = 'home/design-' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.wdtTabName = 'design';
	we._onsemi.webInfo.buttonName = 'Open';
	we._onsemi.webInfo.buttonType = 'Open';
	we._onsemi.webInfo.buttonHref = linkURL;

	sendEvent(we);
};

export const adobeDownloadReport = (partNumber, inputParameters) => {
	const { supplyType, vinMin, vinMax, vout, iout } = inputParameters;
	const we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityAssetTitle = `WebDesign+${partNumber}-${supplyType}-${vinMin} to ${vinMax} V ${vout}V at ${iout}A-report`;
	we._onsemi.activityInfo.activityProductName = 'WebDesigner+ Power Supply';
	we._onsemi.activityInfo.activityType = 'Web Designer Tool';
	we._onsemi.activityInfo.activityTealiumEvent = 'wdt_download_report';
	we._onsemi.activityInfo.activityDescription = 'home/summary-' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.wdtTabName = 'summary';
	we._onsemi.webInfo.buttonName = 'PRINT REPORT';
	we._onsemi.webInfo.buttonType = 'Download';

	sendEvent(we);
};

export const adobeDownloadBom = (partNumber, inputParameters) => {
	const { supplyType, vinMin, vinMax, vout, iout } = inputParameters;
	const we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityAssetTitle = `WebDesign+${partNumber}-${supplyType}-${vinMin} to ${vinMax} V ${vout}V at ${iout}A-bom`;
	we._onsemi.activityInfo.activityProductName = 'WebDesigner+ Power Supply';
	we._onsemi.activityInfo.activityType = 'Web Designer Tool';
	we._onsemi.activityInfo.activityTealiumEvent = 'wdt_download_bom';
	we._onsemi.activityInfo.activityDescription = 'home/summary-' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.wdtTabName = 'summary';
	we._onsemi.webInfo.buttonName = 'icon';
	we._onsemi.webInfo.buttonType = 'Download';

	sendEvent(we);
};

export const adobeCalculateDesign = inputParameters => {
	const { supplyType, vinMin, vinMax, vout, iout } = inputParameters;
	const we = structuredClone(webEvent);
	const linkURL = window.location.href.replace('inputs', 'select');
	we._onsemi.activityInfo.activityLink = linkURL;
	we._onsemi.activityInfo.activityAssetTitle = `WebDesign+${supplyType}-${vinMin} to ${vinMax} V ${vout}V at ${iout}A-report`;
	we._onsemi.activityInfo.activityProductName = 'WebDesigner+ Power Supply';
	we._onsemi.activityInfo.activityType = 'Web Designer Tool';
	we._onsemi.activityInfo.activityTealiumEvent = 'wdt_calculates_designs';
	we._onsemi.activityInfo.activityDescription = 'home/input-' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.wdtTabName = 'input';
	we._onsemi.webInfo.buttonName = 'CALCULATE DESIGNS';
	we._onsemi.webInfo.buttonType = 'Open';
	we._onsemi.webInfo.buttonHref = linkURL;

	sendEvent(we);
};

export const adobeOpenSimilarProducts = (partNumber, linkURL, buttonName) => {
	const we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = linkURL;
	we._onsemi.activityInfo.activityAssetTitle = `Similar products for ${partNumber}`;
	we._onsemi.activityInfo.activityProductName = 'WebDesigner+ Power Supply';
	we._onsemi.activityInfo.activityType = 'Web Designer Tool';
	we._onsemi.activityInfo.activityTealiumEvent = 'wdt_open_similarProducts';
	we._onsemi.activityInfo.activityDescription = 'home/summary-' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.wdtTabName = 'summary';
	we._onsemi.webInfo.buttonName = buttonName;
	we._onsemi.webInfo.buttonType = 'Open';
	we._onsemi.webInfo.buttonHref = linkURL;

	sendEvent(we);
};

const sendEvent = async we => {
	return alloy('getIdentity')
		.then(identity => {
			const mainIdentityKey = buildIdentityObj(identity.identity.ECID, true);
			we.identityMap.ECID = [];
			we.identityMap.ECID.push(mainIdentityKey);
		})
		.then(async () => {
			await api.getUserInfo().then(data => {
				if (data.email) {
					we._onsemi.myon.firstName = data.firstName;
					we._onsemi.myon.lastName = data.lastName;
					we._onsemi.myon.email = data.email;
					we.personalEmail = {
						address: data.email
					};
					we.person = {
						firstName: data.firstName,
						lastName: data.lastName
					};
					we.identityMap.Email = [];
					const emailIdentityKey = buildIdentityObj(data.email, false);
					we.identityMap.Email.push(emailIdentityKey);
				}
			});
		})
		.then(() => {
			try {
				const fullURL = we._onsemi.webInfo.fullUrl ? we._onsemi.webInfo.fullUrl : window.location.href;
				const path = we._onsemi.webInfo.urlPath ? we._onsemi.webInfo.urlPath : window.location.pathname;
				we.web.webReferrer.type = getReferrerType();
				setMiscFields(we, fullURL);
				setUtmFields(we, fullURL);
				setLinkPath(we, fullURL, path);
			} catch (e) {
				console.log(e);
			}
			return alloy('sendEvent', {
				xdm: we
			});
		});
};

const buildIdentityObj = (id, primary) => {
	return {
		id: id,
		primary: primary
	};
};

const setMiscFields = (we, fullURL) => {
	const date = new Date();
	we._onsemi.activityInfo.activityTime = date.toISOString();
	const url = new URL(fullURL);
	we._onsemi.activityInfo.activitySource = url.hostname;
	we.environment.browserDetails.acceptLanguage = navigator.language || navigator.userLanguage;
	we.environment.browserDetails.cookiesEnabled = navigator.cookieEnabled;
	we.environment.browserDetails.name = browser.getBrowserName();
	we.placeContext.geo._schema.latitude = -88.888;
	we.placeContext.geo._schema.longitude = -88.888;
	setSessionId(we, date);
};

const setSessionId = (we, date) => {
	we._onsemi.webInfo.sessionId = 1;
	try {
		if (window && window._satellite) {
			const visNum = String(window._satellite.getVar('visitNum'));
			if (visNum) {
				we._onsemi.webInfo.sessionId = Number(visNum);
			}
		}
	} catch (e) {
		console.log(e);
	}
};

const setUtmFields = (we, fullUrl) => {
	const url = new URL(fullUrl);
	if (url.searchParams.get('utm_source')) {
		we._onsemi.webInfo.queryString = fullUrl.split('?', 2)[1];
		we._onsemi.utmInfo.utmSource = url.searchParams.get('utm_source');
	}
	if (url.searchParams.get('utm_medium')) {
		we._onsemi.utmInfo.utmMedium = url.searchParams.get('utm_medium');
	}
	if (url.searchParams.get('utm_content')) {
		we._onsemi.utmInfo.utmContent = url.searchParams.get('utm_content');
	}
	if (url.searchParams.get('utm_region')) {
		we._onsemi.utmInfo.utmRegion = url.searchParams.get('utm_region');
	}
	if (url.searchParams.get('utm_campaign')) {
		we._onsemi.utmInfo.utmCampaign = url.searchParams.get('utm_campaign');
	}
	if (url.searchParams.get('utm_term')) {
		we._onsemi.utmInfo.utmTerm = url.searchParams.get('utm_term');
	}
};

const getReferrerType = () => {
	if (window.location.search.includes('utm')) {
		return 'external';
	} else if (
		document.referrer.includes(
			'google.' || 'bing.' || 'baidu.' || 'www.so.com' || 'yandex.' || 'sogou.' || 'rakuten.' || 'yahoo.'
		)
	) {
		return 'search_engine';
	} else if (
		document.referrer.includes(
			'facebook' ||
				'fb' ||
				'instagram' ||
				'linkedin' ||
				'youtube' ||
				'reddit' ||
				'wechat' ||
				'whatsapp' ||
				'twitter' ||
				'vk.com' ||
				'zhihu'
		)
	) {
		return 'social';
	} else if (document.referrer.includes('.onsemi.')) {
		return 'internal';
	} else if (document.referrer.length > 1) {
		return 'typed_bookmarked';
	} else {
		return 'unknown';
	}
};

const setLinkPath = (we, fullUrl, path) => {
	we._onsemi.webInfo.fullUrl = fullUrl;
	we._onsemi.webInfo.mainUrl = fullUrl.indexOf('?') > 0 ? fullUrl.split('?')[0] : fullUrl;
	we._onsemi.webInfo.urlPath = path;
	const ps = path.split('/');
	for (let i = 1; i < ps.length && i <= 6; i++) {
		if (ps[i]) {
			we._onsemi.webInfo['urlPath' + i] = ps[i];
		}
	}
};
